import React from 'react';

const ModalContent = ({ children }) => {
    return (
        <div>
            {children}
        </div>
    );
};

export default ModalContent;
